module.exports = __webpack_public_path__ + "fonts/5.svg";